export default __webpack_public_path__ + "static/media/microphone.bead9d13.gif";